import { isDefined } from "./isDefined.js";
export const pluckIds = (items, idGetter) => {
    const ids = items.map(idGetter).flat(10).filter(isDefined);
    return [...new Set(ids)];
};
